// Role definitions mirror r2b-restaurant-mobile-new/src/constants/roles.js.
// These strings must match the backend role `name` values exactly.
export const USER_ROLES = {
  CUSTOMER: 'customer',
  BRANCH_MANAGER: 'branch_manager',
  RESTAURANT_OWNER: 'restaurant_owner',
};

export const ALLOWED_ROLES = [USER_ROLES.BRANCH_MANAGER, USER_ROLES.RESTAURANT_OWNER];
